import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Import useNavigate
import logoLanding from '../assets/logo_landing_page.png';
import logoRegister from '../assets/logo_register_page.png';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Initialize useNavigate
  const isLanding = location.pathname === '/';
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';
  const isLoggedIn = localStorage.getItem('token'); // Check for token
  const [dropdownOpen, setDropdownOpen] = React.useState(false); // Add dropdown state

  const logo = isLanding ? logoLanding : logoRegister;
  const navTheme = isLanding ? 'navbar-dark' : 'navbar-light';

  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove user token
    localStorage.removeItem('admin_token'); // Remove admin token if present
    navigate('/login'); // Redirect to login page
  };

  return (
    <nav className={`navbar navbar-expand-lg shadow-sm navbar-cuda ${navTheme}`}>
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="CUDA Logo" className="navbar-logo" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {isLoggedIn ? (
              <>
                {/* Links for logged-in users */}
                <li className="nav-item">
                  <Link className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`} to="/dashboard">
                    Dashboard
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className={`nav-link ${location.pathname === '/pricing' ? 'active' : ''}`} to="/pricing">
                    Planes
                  </Link>
                </li>
                <li className={`nav-item dropdown ${dropdownOpen ? 'show' : ''}`}>
                  <a
                    className="nav-link dropdown-toggle btn btn-primary ms-lg-3 text-white"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    aria-expanded={dropdownOpen}
                  >
                    <i className="bi bi-person-circle me-1"></i> Mi Cuenta
                  </a>
                  <ul className={`dropdown-menu dropdown-menu-end ${dropdownOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
                    <li><Link className="dropdown-item" to="/profile" onClick={() => setDropdownOpen(false)}>Mi Perfil</Link></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><button className="dropdown-item text-danger" onClick={handleLogout}>Cerrar Sesión</button></li>
                  </ul>
                </li>
              </>
            ) : (
              <>
                {/* Links for non-logged-in users */}
                <li className="nav-item">
                  <a className="nav-link" href="/#features">
                    Características
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#pricing">
                    Precios
                  </a>
                </li>
                {!isAuthPage && (
                  <li className="nav-item">
                    <Link className="btn btn-primary ms-lg-3" to="/login">
                      Ingresar
                    </Link>
                  </li>
                )}
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
